import Icon from "@mui/icons-material/BookmarkAdded";
import MakhsoosItsDataList from "./MakhsoosItsDataList";
import MakhsoosItsDataCreate from "./MakhsoosItsDataCreate";
import MakhsoosItsDataEdit from "./MakhsoosItsDataEdit";

export default {
  list: MakhsoosItsDataList,
  create: MakhsoosItsDataCreate,
  edit: MakhsoosItsDataEdit,
  icon: Icon,
  label: "Makhsoos ITS",
  options: { label: "Makhsoos ITS" },
  name: "makhsoosItsData",
};
